import 'dayjs/locale/ko';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/charts/styles.css';
import MainLayout from "./components/MainLayout";
import { Routes, Route, useLocation } from "react-router-dom";
import Login from "./Login";

import ProtectedRoute from "./ProtectedRoute";
import ServerHealthChecker from './components/ServerHealthChecker';

import { AuthProvider } from "./contexts/AuthContext";
import { ModalProvider } from "./contexts/useModal";
import { MantineProvider } from "@mantine/core";
import DashBoard from './pages/DashBoard';
import { DatesProvider } from '@mantine/dates';
import { ToastContainer } from 'react-toastify';
import ActionLog from './pages/ActionLog';
import { useEffect, useState } from 'react';
import { MENU_MAP } from './components/MenuData';
import Users from './pages/Users';
import WorkerApproval from './pages/WorkerApproval';
import Workers from './pages/Workers';
import ScsKeyInject from './pages/ScsKeyInject';
import TerminalModels from './pages/TerminalModels';
import Permissions from './pages/Permissions';
import Terminals from "./pages/Terminals";

const MainContent = () => <div>없는페이지입니다.</div>;

function App() {
  const [title,setTitle] = useState("");
  const location = useLocation();
  useEffect(()=>{
      setTitle(MENU_MAP[location.pathname]);
    },[location.pathname]);
    
  return (
    <MantineProvider>
      <DatesProvider settings={{ locale: 'ko', firstDayOfWeek: 0 }}>
        <AuthProvider>
          <ModalProvider>
            <ServerHealthChecker />
            <Routes>
              <Route path="/login" element={<Login />} />

              <Route element={<ProtectedRoute />}>
                <Route element={<MainLayout />}>
                  <Route path="DashBoard" element={<DashBoard menuTitle={title} />} />
                  <Route path="Terminals" element={<Terminals menuTitle={title} />} />
                  <Route path="SCSproSnInject" element={<ScsKeyInject menuTitle={title} />} />
                  <Route path="ScsKeyInject" element={<ScsKeyInject menuTitle={title} />} />
                  <Route path="TerminalModels" element={<TerminalModels menuTitle={title} />} />
                  <Route path="ActionLog" element={<ActionLog menuTitle={title} />} />
                  <Route path="Users" element={<Users menuTitle={title} />} />
                  <Route path="Permissions" element={<Permissions menuTitle={title} />} />
                  <Route path="Workers" element={<Workers menuTitle={title} />} />
                  <Route path="WorkerApproval" element={<WorkerApproval menuTitle={title} />} />
                  <Route path="*" element={<MainContent />} />
                </Route>
              </Route>
            </Routes>
          </ModalProvider>
        </AuthProvider>
      </DatesProvider>
      <ToastContainer
        theme="colored"
        position="bottom-right"
        limit={3}
        newestOnTop={true}
      />
    </MantineProvider>
  );
}

export default App;
